export enum CHECKIN_STATUS {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  CLOSED_DOMESTIC_WINDOW = 'CLOSED_DOMESTIC_WINDOW',
  CLOSED_INTERNATIONAL_WINDOW = 'CLOSED_INTERNATIONAL_WINDOW',
  CLOSED_NOT_OPERATED_BY_AM = 'CLOSED_NOT_OPERATED_BY_AM',
  CLOSED_GROUND_HANDLING_BY_DL = 'CLOSED_GROUND_HANDLING_BY_DL',
  CLOSED_GROUND_HANDLING_BY_AF = 'CLOSED_GROUND_HANDLING_BY_AF',
  CLOSED_GROUND_HANDLING_BY_KL = 'CLOSED_GROUND_HANDLING_BY_KL',
  CLOSED_GROUND_HANDLING_BY_LF = 'CLOSED_GROUND_HANDLING_BY_LF',
  CLOSED_GROUND_HANDLING_BY_LH = 'CLOSED_GROUND_HANDLING_BY_LH',
  CLOSED_GROUND_HANDLING_BY_ATO = 'CLOSED_GROUND_HANDLING_BY_ATO',
  CHECKIN_NOT_ALLOWED_SANITARY_RESTRICTIONS = 'CHECKIN_NOT_ALLOWED_SANITARY_RESTRICTIONS',
  CHECKIN_NOT_ALLOWED_RESTRICTED_CHECKIN = 'CHECKIN_NOT_ALLOWED_RESTRICTED_CHECKIN',
  BOARDING = 'BOARDING',
  IN_FLIGHT = 'IN_FLIGHT',
  FINAL = 'FINAL',
  CANCEL = 'CANCEL',
  HELD = 'HELD',
  CKI = 'CKI',
  MYB = 'MYB',
}
export enum FARES_FAMILY {
  BASIC = 'BASIC',
  CLASSIC = 'CLASSIC',
  AMPLUS = 'AMPLUS',
  PREMIER = 'PREMIER',
  FLEXIBLE = 'FLEXIBLE',
  FIRST_CLASS = 'FIRST_CLASS',
  COMFORT = 'COMFORT',
  MAIN_LIGHT = 'MAIN_LIGHT',
  MAIN_BASIC = 'MAIN_BASIC',
  MAIN_CLASSIC = 'MAIN_CLASSIC',
  AMPLUS_BASIC = 'AMPLUS_BASIC',
  PREMIER_BASIC = 'PREMIER_BASIC',
  PREFERRED = 'PREFERRED',
  EXIT_ROW = 'EXIT_ROW',
}

export const CARRY_ON_FLOW_FARE_FAMILIES: FARES_FAMILY[] = [
  FARES_FAMILY.MAIN_LIGHT,
  FARES_FAMILY.MAIN_BASIC,
  FARES_FAMILY.AMPLUS_BASIC,
  FARES_FAMILY.PREMIER_BASIC,
];

export const CARRY_ON_BASIC_FARE_FAMILIES: FARES_FAMILY[] = [
  FARES_FAMILY.MAIN_BASIC,
  FARES_FAMILY.AMPLUS_BASIC,
  FARES_FAMILY.PREMIER_BASIC,
];

export enum FLIGHT_STATUS {
  FLOWN = 'FLOWN',
  ON_TIME = 'ON_TIME',
  DELAYED = 'DELAYED',
  ON_AIR = 'ON_AIR',
  CANCELLED = 'CANCELLED',
  CLOSED = 'CLOSED',
  FINAL = 'FINAL',
  UNKNOWN = 'UNKNOWN',
}

export enum MARKET_FLIGHT {
  DOMESTIC = 'DOMESTIC',
  CENTROAMERICA_CARIBE = 'CENTROAMERICA_CARIBE',
  SUDAMERICA_ASIA = 'SUDAMERICA_ASIA',
  EUROPA = 'EUROPA',
  INTERNATIONAL = 'INTERNATIONAL',
  CANADA = 'CANADA',
  TRANSBORDER = 'TRANSBORDER',
}

export enum REGION_KEY {
  MX = 'MX',
  BR = 'BR',
  NA = 'NA',
  AS = 'AS',
  EU = 'EU',
  IN = 'IN',
  GRU = 'GRU',
  HAV = 'HAV',
  CAR = 'CAR',
  SUD = 'SUD',
  NAL = 'NAL',
  USA = 'USA',
  CAN = 'CAN',
  ASI = 'ASI',
  EUR = 'EUR',
  CAM = 'CAM',
  ANY = 'ANY',
  CAM_SJO = 'CAM_SJO',
  USA_GRU_USA = 'USA_GRU_USA',
  NO_USA_GRU_USA = 'NO_USA_GRU_USA',
  LATAM = 'LATAM',
}

export enum SEAT_SELECTION_TYPE {
  BUY = 'BUY_BACK',
  SHOW_SEATMAP = 'SHOW_SEATMAP',
  HIDE_SEATMAP = 'HIDE_SEATMAP',
}

export enum LEG_TYPE {
  NON_STOP = 'NON-STOP',
  CONNECTING = 'CONNECTING',
  THRU = 'THRU',
  TRANSFER = 'TRANSFER',
}
export enum FLIGHT_ITINERARY_TYPE {
  ONEWAY = 'ONEWAY',
  ROUNDTRIP = 'ROUNDTRIP',
  MULTICITY = 'MULTICITY',
}
export enum FLIGHT_ITINERARY_TYPE_MICRO {
  ONEWAY = 'One-Way',
  ROUNDTRIP = 'Round-Trip',
  MULTICITY = 'Multi-City',
}

export enum MISSING_CHECKIN_REQUIRED_FIELDS {
  PASSENGER_TRACING_CONTACT_PHONE = 'PASSENGER_TRACING_CONTACT_PHONE',
  PASSENGER_TRACING_CONTACT_EMAIL = 'PASSENGER_TRACING_CONTACT_EMAIL',
  EMERGENCY_CONTACT = 'EMERGENCY_CONTACT',
  ESTA = 'ESTA',
  PASSPORT = 'PASSPORT',
  COUNTRY_OF_RESIDENCE = 'COUNTRY_OF_RESIDENCE',
  DESTINATION_ADDRESS = 'DESTINATION_ADDRESS',
  TIM = 'TIM',
  TIM_INF = 'TIM/INF',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  VISA = 'VISA',
  VISA_US = 'VISA_US',
  VISA_INF = 'VISA/INF',
  RETURN_DATE = 'RETURN_DATE',
  RETURN_DATE_INF = 'RETURN_DATE/INF',
  PASSPORT_INF = 'PASSPORT/INF',
  DESTINATION_ADDRESS_INF = 'DESTINATION_ADDRESS/INF',
  PERMANENT_RESIDENT_CARD = 'PERMANENT_RESIDENT_CARD',
}

export enum GENDER_TYPE {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  UNKNOWN = 'UNKNOWN',
  X = 'X',
  MALE_ID = 'M',
  FEMALE_ID = 'F',
  UNKNOWN_ID = 'U',
}

export enum FLIGHT_STATUS {
  OPENCI_ST = 'OPENCI',
  FINAL_ST = 'FINAL',
  CLOSE_ST = 'CLOSE',
}
